/**
 * Tarih yardımcıları.
 * toISOString().split('T')[0] UTC tarih verir; Türkiye gibi UTC+3'te 23 Şubat 00:00
 * seçildiğinde "2025-02-22" döner. Kullanıcının seçtiği günü korumak için
 * yerel tarih string'i (YYYY-MM-DD) kullanın.
 */
export function toLocalDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * "YYYY-MM-DD" string'ini yerel tarih olarak parse eder.
 * new Date("YYYY-MM-DD") UTC gece yarısı sayıldığı için Türkiye gibi UTC+3'te
 * sayfa yenilenince bir gün geriye düşer. Bu fonksiyon yerel günü korur.
 */
export function parseLocalDateString(value: string): Date | null {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return null;
  const [y, m, d] = trimmed.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}
